/* JS file to update non-table part of client order list, not currently used */

// order stats and params rendering
//var order;
function renderOrderList(input) {
  //order = input;

  var data = {order:input};
  $('#orderHeader').html(Handlebars.templates["orders/client_detail_header.html"](data));
  $('#orderParameters').html(Handlebars.templates["orders/client_detail_parameters.html"](data));
  $('#orderStats').html(Handlebars.templates["orders/client_detail_stats.html"](data));


}

function updateOrderList() {
  var orderPromise = new Promise(function(resolve, reject) {

    $.ajax({
               type: "GET",
               url: '/api/client_orders/stats/',
               success: function(data) {
                 resolve(data);
                 renderOrder(data);
               },
               error: function(data)
               {
                  throw new Error(data);
                  console.log(data);
                  console.log("error in render")
               }
             });


  });
  return orderPromise
}

var orderListTable;

function refreshOrderList() {
  //updateOrderList();
  if (orderListTable) {
    orderListTable.refresh();
  }
}
